import { useEffect, useState } from "react";
import { formatINR, formatDate as sharedFormatDate } from "../../../../utils/format";

// Shared helpers for the consolidated Fees page tabs. Currency + date formatting
// come from the app-wide utils/format so the admin tabs and the student "My Fees"
// page render amounts/dates identically; re-exported here under the names the
// tabs already use.

export const formatCurrency = formatINR;

export const formatDate = sharedFormatDate;

export const formatDateTime = (date) => {
  if (!date) return "N/A";
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return "N/A";
  return d.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

// Debounce hook — used by the Payments and Receipts tabs for search inputs.
export const useDebounce = (value, delay = 400) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(handler);
  }, [value, delay]);
  return debouncedValue;
};

export const LoadingSpinner = () => (
  <div className="flex justify-center items-center h-64">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
  </div>
);
